import React from 'react'
import httpClient from '../myapi'
import LazyLoad from 'react-lazyload'
import '../styles/gallery.css'
// import Icon from '../styles/icon';
import MyLightBox from '../MyLightBox'
import ImageCard from '../ImageCard'
import { Button } from 'reactstrap'
import ManageModal from './manageImg_md'
// import { connect } from 'react-redux'
// import { bkupCategories } from '../redux/actions';
// import store from '../redux/store';
import { Link } from 'react-router-dom';
import ConfirmDelMd from './ConfirmDelMd';

// const _webserver = httpClient.WebServer + '/imgs/gallery/';

class AdminGallery1 extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            allCols: [],
            allImgs: [],
            showLightBox: false,
            photoIndex: 0,
            showModal: false,
            showDelModal: false
        }

        this.modalAction = 1;
        this.state.currentImg = null;
    }
    componentDidMount() {
        //CHECK IF LOGGED IN
        if (localStorage.getItem('isLoggged') !== '111') {
            this.props.history.replace('/login');
            return;
        }

        this.getImages();

        
    }
    getImages = () => {
        console.log('getting new imgs');
        
        httpClient.get('/getImages.php').then((res) => {
            if (res.length) {
                this.divideImgs(res)
            } else {
                alert("No Internet")
            }
        })
    }
    onNewImg = () => {
        this.setState({ showModal: false, allImgs:[]});
        this.getImages();
    }
    divideImgs = (res) => {

        const col1 = [], col2 = [], col3 = [], col4 = [], allCols = []
        //DIVIDE IMAGES IN 4 COLUMNS
        const max = parseInt(res.length, 10) / 4
        for (let j = 0, i = 0; j < max; j++ , i += 4) {
            col1.push(res[i])

            if (res[i + 1] !== void 0) {//CHECK IF KEY EXIST
                col2.push(res[i + 1])
            }
            if (res[i + 2] !== void 0) {
                col3.push(res[i + 2])
            }
            if (res[i + 3] !== void 0) {
                col4.push(res[i + 3])
            }
        }

        allCols.push(col1)
        allCols.push(col2)
        allCols.push(col3)
        allCols.push(col4)

        //INITIALLY NO IMAGES LOADED, SHOW BLUR OVERLAY
        // const arr = []
        // res.forEach(elem => {
        //     arr.push({ ["x" + elem.id]: 0 })
        // });

        this.setState({
            allCols: allCols,
            allImgs: res //for lightbox
        })
    }
    openLightbox = (imgId) => {
        const arr = this.state.allImgs.slice()
        const max = arr.length
        let index = -1;
        for (let i = 0; i < max; i++) {
            if (arr[i].id === imgId) {
                index = i;
                break;
            }
        }
        this.setState({
            photoIndex: index,
            showLightBox: true
        })
    }
    closeLightBox = () => {
        this.setState({
            showLightBox: false
        })
    }
    showAddNew = (action, img) => {
        this.currentImg = img;
        this.modalAction = action;

        this.setState({
            showModal: !this.state.showModal
        })
    }
    confirmDelete = (img) =>{
        this.currentImg = img;
        this.setState({ showDelModal: !this.state.showDelModal })
    }
    onDelProd = () => {
        this.setState({ showDelModal: false, allImgs: [] });
        this.getImages();
    }
    render() {
        const { showLightBox, allImgs, photoIndex } = this.state

        return (
            <div className="blank-page">
                <h1 className="page-heading">Gallery
                    <Button className="theme-button" size="sm"
                        style={{ float: 'right', marginRight: '5px' }}
                        onClick={() => this.showAddNew(1, null)}
                    > Add new item</Button>

                    <Link to="/category"><Button className="theme-button" size="sm"
                        style={{ float: 'right', marginRight: '5px' }}
                        onClick={() => this.showAddNew(1, null)}
                    > Category
                    </Button>
                    </Link>
                </h1>
                {showLightBox &&
                    <MyLightBox allImgs={allImgs} photoIndex={photoIndex} closeHandler={this.closeLightBox} />
                }

                <div className="gallery-row">
                    {
                        this.state.allCols.map((col, j) => (
                            <div key={j} className="gallery-col">
                                {
                                    col.map((img, ind) => (
                                        <LazyLoad key={ind} height={80} once offset={100}>
                                            <ImageCard key={ind}
                                                img={img}
                                                onclick={() => this.openLightbox(img.id)}
                                                isAdmin={true}
                                                secondAction={() => this.showAddNew(2, img)}
                                                onDel={() =>this.confirmDelete(img) }
                                            />
                                        </LazyLoad>
                                    ))
                                }
                            </div>
                        ))
                    }
                </div>
                {
                    this.state.showModal &&
                    <ManageModal
                        toclose={this.showAddNew}
                        action={this.modalAction}
                        img={this.currentImg}
                        onsuccess={this.onNewImg}
                    />
                }
                {
                    this.state.showDelModal && 
                    <ConfirmDelMd
                        closeDel={this.confirmDelete}
                        img={this.currentImg}
                        delProd={() => this.delProd(this.currentImg.id)}
                        onsuccess={ this.onDelProd }
                    />
                }
            </div>
        )
    }
}

// const mapStateToProps = state => {
//     return { newImageAdded1: state.newImageAdded1 }
// }

// const AdminGallery = connect(mapStateToProps)(AdminGallery1)

export default AdminGallery1;


// WEBPACK FOOTER //
// ./src/admin/adminGallery.jsx